<template>
  <div>
    <!-- <h1>This is the home</h1> -->
    
  <button @click="showMessageForm = !showMessageForm" type="button" class="btn btn-outline-success my-2">Say Something</button>
    <form v-if="showMessageForm" @submit.prevent="addMessage">
      
      <div v-if="error" class="alert alert-dismissible alert-danger">
        <button type="button" class="close" data-dismiss="alert">&times;</button>
        <h4 class="alert-heading">Error!</h4>
        <p class="mb-0">{{error}}</p>
      </div>
      
      <div class="form-group">
        <label for="username">Username</label>
        <input type="text" v-model="message.username" class="form-control" id="username" placeholder="Default: Anonymous">
      </div>
      <div class="form-group">
        <label for="imageURL">Your Image URL</label>
        <input type="url" v-model="message.imageURL" class="form-control" id="imageURL" placeholder="Optional">
      </div>
      <div class="form-group">
        <label for="subject">Subject</label>
        <input type="text" v-model="message.subject" class="form-control" id="subject" placeholder="Default: General">
      </div>
      <div class="form-group">
        <label for="message">Say Something <span class="text-danger">*</span></label>
        <textarea class="form-control" v-model="message.message" id="message" rows="3" placeholder="What's in your mind? ^_^" required></textarea>
      </div>
      <button type="submit" class="btn btn-outline-success">Send</button>
    </form>
    <hr>

    <!-- list of messages -->
    <div class="list-unstyled" v-for="message in reverseMessages" :key="message._id">
      <li class="media" >
        <img v-if="message.imageURL" class="mr-3" :src="message.imageURL" :alt="message.subject">
        <div class="media-body">
          <div class="mt-0 mb-1 d-flex">
            <span class="mr-auto font-weight-bold">{{message.username}}</span>
            <span class="text-success">#{{message.subject}}</span>
          </div>
          {{message.message}}
          <br>
          <small>{{message.created}}</small>
        </div>
      </li>
      <hr>
    </div>
  </div>
</template>

<script>
// const API_URL = 'http://localhost:1234/messages';
const API_URL = 'https://mean-chatroom.herokuapp.com/messages';

export default {
  // name: 'app',
  name: 'home',
  data: () => ({
    showMessageForm: false,
    messages: [],
    error: '',
    message: {
      username: '',
      subject: '',
      message: '',
      imageURL: '',
    }
  }),
  computed: {
    reverseMessages() {
      return this.messages.slice().reverse();
    }
  },
  mounted() {
    fetch(API_URL).then(response => response.json()).then(result => {
      console.log(result);
      this.messages = result;
    });
  },
  methods: {
    addMessage() {
      // console.log(this.message);
      fetch(API_URL, {
        method: 'POST',
        body: JSON.stringify(this.message),
        headers: {
          'content-type': 'application/json'
        }
      }).then(response => response.json()).then(result => {
        // console.log(result);
        if (result.details) {
          const error = result.details.map(detail => detail.message).join('. ');
          // console.log(error);
          this.error = error;
        } else {
          this.error = '';
          this.showMessageForm = false;
          this.messages.push(result);
        }
      });   
    }
  }
}
</script>

<style>
  hr {
    border-top: 1px solid white;
  }
  img {
    max-width: 70px;
    height: auto;
  }
</style>